class ResponseShortTextboxResponsePDFValidator {
    /**
     * Constructs a new instance of the ResponseShortTextboxResponsePDFValidator class.
     * @param {Object} model - The model object to be validated.
     * @param {Object} $injector - The AngularJS injector service.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.LOGIC.RESPONSE-SHORT-TEXT-PDF';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Retrieves the translate service from the injector.
     * @returns {Object} The translate service.
     */
    getTranslateService() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model based on the includedInPDF preference.
     * @param {Object} from - The source object triggering the validation.
     * @returns {Object} The validation result.
     */
    validate(from) {
        let error = false;

        const preferences = this.model.getPreferences();
        let includedInPDF = preferences ? preferences.includedInPDF : undefined;

        if (typeof includedInPDF === 'undefined') {
            const objTypeProps = ContentObjectRegistryService.getObjectProperties(this.model.getObjectType());
            if (objTypeProps && objTypeProps.obj && objTypeProps.obj.preferences) {
                includedInPDF = objTypeProps.obj.preferences.includedInPDF;
            }
        }

        if (includedInPDF === false) {
            error = true;
        }

        return {
            'onSheetBlur': true,
            'onlyBanner': false,
            'validator': this.getValidatorName(),
            'modelUUID': this.model.getUUID(),
            'error': error,
            'status': error ? 'DANGER' : 'SUCCESS',
            'message': this.getErrorMessage(),
            'message_template': false,
            'callbacks': [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };
    }

    /**
     * Retrieves the error message for the validation.
     * @returns {string} The error message.
     */
    getErrorMessage() {
        const questionHeadline = this.model.getQuestionHeadline();
        this._message = this.getTranslateService().instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Checks if the validation is a forced check.
     * @returns {boolean} True if the validation is a forced check, otherwise false.
     */
    isForcedCheck() {
        return this._forced_check;
    }

    /**
     * Retrieves the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'ResponseShortTextboxResponsePDFValidator';
    }
}

export default ResponseShortTextboxResponsePDFValidator;